export const VALUE_PROP_COLORS = ["#93B6ED", "#A8B81F", "#E8794D", "#CFBFAB"]

export function PreventionIcon() {
  return (
    <svg
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="rgb(0,0,0)"
      aria-hidden="true"
    >
      <path d="M 16.414 3.092 C 16.414 6.012 12.201 8.989 11 9.564 C 9.8 8.989 5.586 6.013 5.586 3.092 C 5.586 1.384 6.892 0 8.502 0 C 9.517 0 10.288 0.647 10.917 1.398 L 11.083 1.398 C 11.713 0.647 12.483 0 13.498 0 C 15.108 0 16.414 1.384 16.414 3.092 Z M 0 13.965 L 0.43 6.222 C 0.468 5.538 1.03 5 1.715 4.992 C 2.4 4.984 2.974 5.509 3.028 6.192 L 3.434 11.379 C 2.014 12.955 4.28 14.869 6.364 17.316 L 6.921 16.819 L 4.479 13.603 C 4.103 13.111 4.166 12.412 4.626 11.996 C 5.085 11.581 5.787 11.586 6.239 12.01 L 8.721 14.313 C 9.537 15.07 10 16.132 10 17.245 L 10 24 L 5 24 L 5 22.074 L 0.722 15.917 C 0.256 15.373 0 14.681 0 13.965 Z M 22 13.965 L 21.57 6.222 C 21.532 5.538 20.97 5 20.285 4.992 C 19.6 4.984 19.026 5.509 18.972 6.192 L 18.566 11.379 C 19.986 12.955 17.72 14.869 15.636 17.316 L 15.079 16.819 L 17.521 13.603 C 17.897 13.111 17.834 12.412 17.374 11.996 C 16.915 11.581 16.213 11.586 15.761 12.01 L 13.279 14.313 C 12.463 15.07 12 16.132 12 17.245 L 12 24 L 17 24 L 17 22.074 L 21.278 15.917 C 21.744 15.373 22 14.681 22 13.965 Z" />
    </svg>
  )
}

export function InsightsIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="rgb(0,0,0)"
      aria-hidden="true"
    >
      <path d="M 10.8 0.917 C 10.141 0.325 9.286 -0.001 8.4 0 C 5.958 0 3.905 1.834 3.63 4.261 C 1.471 4.937 0 6.937 0 9.2 C 0 11.84 2.4 13.6 4.8 13.6 C 4 14.4 2.546 14.696 1.051 14.136 C 0.256 16.38 1.399 18.848 3.624 19.693 C 3.877 22.14 5.939 24.001 8.4 24 C 9.322 24 10.163 23.653 10.8 23.083 L 10.8 18.262 C 10.8 18.156 10.758 18.054 10.683 17.979 L 9.422 16.718 C 8.373 17 7.266 16.542 6.722 15.601 C 6.179 14.66 6.335 13.472 7.103 12.703 C 7.872 11.935 9.06 11.779 10.001 12.322 C 10.942 12.866 11.4 13.973 11.118 15.022 L 12.379 16.283 C 12.906 16.808 13.2 17.52 13.2 18.262 L 13.2 23.083 C 13.837 23.653 14.678 24 15.6 24 C 18.06 24 20.122 22.14 20.374 19.693 C 22.599 18.847 23.741 16.38 22.947 14.136 C 21.456 14.696 20 14.4 19.2 13.6 C 21.6 13.6 24 11.84 24 9.2 C 24 6.937 22.529 4.937 20.37 4.261 C 20.095 1.834 18.042 0 15.6 0 C 14.678 0 13.837 0.347 13.2 0.917 L 13.2 5.738 C 13.2 5.843 13.242 5.946 13.317 6.021 L 14.578 7.282 C 15.298 7.089 16.068 7.242 16.66 7.696 C 17.252 8.15 17.6 8.854 17.6 9.6 C 17.597 10.531 17.056 11.376 16.212 11.768 C 15.367 12.161 14.372 12.03 13.659 11.432 C 12.945 10.834 12.642 9.877 12.88 8.978 L 11.621 7.717 C 11.096 7.192 10.8 6.48 10.8 5.738 Z" />
    </svg>
  )
}

export function InnovativeIcon() {
  return (
    <svg
      width="25"
      height="27"
      viewBox="0 0 24.999756 27"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M 1 8.143 H 6.308 c 0.977 0 1.769 -0.8 1.769 -1.786 V 1"
        fill="#000"
        stroke="#000"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M 22.231 9.629 V 6.357 C 22.231 3.398 19.854 1 16.923 1 H 8.809 C 8.34 1 7.89 1.188 7.559 1.523 L 1.518 7.62 C 1.187 7.954 1 8.409 1 8.882 V 20.643 C 1 23.602 3.376 26 6.308 26 h 3.949"
        fill="transparent"
        stroke="#000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M 18.25 14.393 19.577 18.857 24 20.196 19.577 21.536 18.25 26 16.923 21.536 12.5 20.196 16.923 18.857 Z"
        fill="#000"
        stroke="#000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function FastResultsIcon() {
  return (
    <svg
      width="30"
      height="27"
      viewBox="0 0 29.999903 26.999081"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M 22 1 18.5 11.714 H 29 l -10.5 14.286 3.5 -10.714 H 11.5 Z"
        fill="#000"
        stroke="#000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M 1 13.5 H 4.5 m 0 -7.143 H 8 M 4.5 20.643 H 8"
        fill="transparent"
        stroke="#000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const VALUE_PROP_ICONS = [
  PreventionIcon,
  InsightsIcon,
  InnovativeIcon,
  FastResultsIcon,
]
